import {Button,Checkbox,FormControlLabel,List,ListItem,Popover,TextField} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { Stack } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {submitUserRoles} from "../Redux/UserMaintanence";
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import ExcelDownload from "./ExcelDownload";
import "./UserAccessTable.css";

function formatTimestamp(timestamp) {
    const date = new Date(timestamp);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = String(date.getFullYear()).slice(-2); // Get last two digits of the year

    return `${day}-${month}-${year}`;
}
  
export default function UserAccessTable({filteredData,trackDetails}) {                   
    const [rows, setRows] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedFilters, setSelectedFilters] = useState({});
    const [currentColumn, setCurrentColumn] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [alertMsg, setAlertMsg] = useState(false);

    let trackDataObj = null;
    try{

        trackDataObj=trackDetails?.reduce((acc, { id, title, lead }) => {
            acc[id] = { title, lead };
            return acc;
          }, {});
    }catch(err){
        console.log(err);
    }

     
    
    const dispatch = useDispatch();

    function handleUserAccessUpdate(e, enterpriseId) {        
        const { name, checked } = e.target;                
        let udatedUserDetail = rows.map(row => row.Enterprise_ID === enterpriseId 
            ?   {
                    ...row, 
                    'Designer' :(name==='Designer'? (checked === true ? 'yes' : 'no') 
                                   :(name==='Admin'?(checked === true ? 'yes' : row.Designer)
                                        :(name === 'isActive'? (checked === true ? 'no' : 'no') 
                                            :row.Designer))),
                
                    'Requestor' :   (name === 'Requestor' ? (checked === true ? 'yes' : 'no') 
                                        : (name === 'Approver' ? (checked === true ? 'yes' : row.Requestor) 
                                            : (name === 'Admin' ? (checked === true ? 'yes' : row.Requestor) 
                                                : (name === 'isActive'? (checked === true ? 'no' : 'no') 
                                                    : row.Requestor)))),
                    'Approver'  :   (name === 'Approver' ? (checked === true ? 'yes' : 'no') 
                                        : (name === 'Admin' ? (checked === true ? 'yes' : row.Approver) 
                                            : (name === 'Requestor' ? (checked === true ? 'no' : 'no') 
                                                :   (name === 'isActive'? (checked === true ? 'no' : 'no') 
                                                    : row.Approver)))),
                    'Admin'     :   (name === 'Admin' ? (checked === true ? 'yes' : 'no') 
                                        : (name === 'Approver' ? (checked === true ? 'no' : 'no')
                                            : (name === 'Requestor' ? (checked === true ? 'no' : 'no') 
                                                : (name === 'isActive' ? (checked === true ? 'no' : 'no') 
                                                    : row.Admin)))),
                    'isActive'  :   name === 'isActive' ?( checked === true ? 'yes' : 'no'):'yes'
                                                           
                } 
            : row)                
        setRows(udatedUserDetail);
    }

    const handleSubmitClick = () => {            
        dispatch(submitUserRoles(rows));  
        setAlertMsg(true);
        setTimeout(()=>{
            setAlertMsg(false);
        },3000)      
    };

    // const handleFilterClick = (event, column) => {
    //     setCurrentColumn(column);
    //     setAnchorEl(event.currentTarget);
    // };

    const handleFilterClose = () => {
        setAnchorEl(null);
        setCurrentColumn(null);
        setSearchTerm("");
    };

    const handleSelection = (value, bool) => {
        const columnFilters = selectedFilters[currentColumn];        
    };

    const handleReset = () => {
        setSelectedFilters({});
        setRows(filteredData.map((item, sno) => ({ ...item, id: sno })));        
        handleFilterClose();
    };    

    const columns = [
        {
            field: "id",
            headerName: <div style={{ display: "flex" }}>SI#</div>,
            minWidth: 50,
            sortable: true,
            flex: 1,
            headerClassName: "center-header", 
            cellClassName: "center-cell", 
        },
        {
            field: "Enterprise_ID", minWidth: 160, sortable: true, flex: 1, headerClassName: "center-header", 
            cellClassName: "left-cell",
            align: 'left',
            headerName: (
                <div style={{ display: "flex", alignItems: "center" }}>
                    Enterprise Id                
                </div>
            ),             
        },
        {
            field: "track", minWidth: 300, sortable: true, flex: 1, headerClassName: "center-header",
            cellClassName: "left-cell",
            headerName: "Track",        
            renderCell: (params) => <p>{trackDataObj&&trackDataObj[params.row.track]?.title}</p>                    
        },
        {
            field: "Designer",
            headerName: (
                <div style={{ display: "flex", alignItems: "center" }}>
                    Designer
            </div>
            ),
            minWidth: 50, sortable: true, flex: 1, headerClassName: "center-header", cellClassName: "center-cell", 
            renderCell: (params) => <div>                
                <input type="checkbox" name="Designer" checked={(params.row.Designer == 'yes' ? true : false)} 
                    onChange={(e) => handleUserAccessUpdate(e,params.row.Enterprise_ID)} />                 
            </div>                                            
        },
        {
            field: "Requestor",
            headerName: (
                <div style={{ display: "flex", alignItems: "center" }}>
                    Requestor
            </div>
            ),
            minWidth: 50, sortable: true, flex: 1, headerClassName: "center-header", cellClassName: "center-cell", 
            renderCell: (params) => <div>                
                <input type="checkbox" name="Requestor" checked={(params.row.Requestor == 'yes' ? true : false)} 
                    onChange={(e) => handleUserAccessUpdate(e,params.row.Enterprise_ID)} />                 
            </div>                                            
        },
        {
            field: "Approver",
            headerName: (
                <div style={{ display: "flex", alignItems: "center" }}>
                    Approver
                {/* <div>
                    <FilterAltIcon
                        style={{ width: "15px", marginTop: "6px", marginLeft: "3px" }}
                        onClick={(e) => handleFilterClick(e, "Approver")}
                    />
                </div> */}
            </div>
            ),
            minWidth: 50,
            sortable: true,
            flex: 1,
            headerClassName: "center-header", 
            cellClassName: "center-cell", 
            renderCell: (params) => <div>
                <input type="checkbox" name="Approver" checked={params.row.Approver == 'yes' ? true : false}
                    onChange={(e) => handleUserAccessUpdate(e,params.row.Enterprise_ID)} />                 
            </div>
        },
        {
            field: "Admin",
            headerName: (
                <div style={{ display: "flex", alignItems: "center" }}>
                    Admin
                {/* <div>
                    <FilterAltIcon
                        style={{ width: "15px", marginTop: "6px", marginLeft: "3px" }}
                        onClick={(e) => handleFilterClick(e, "Admin")}
                    />
                </div> */}
            </div>
            ),
            minWidth: 50,
            sortable: true,
            flex: 1,
            headerClassName: "center-header", 
            cellClassName: "center-cell", 
            renderCell: (params) => <div>
                <input type="checkbox" name="Admin" checked={params.row.Admin == 'yes' ? true : false}
                    onChange={(e) => handleUserAccessUpdate(e,params.row.Enterprise_ID)} />                 
            </div>
        },
        {
            field: "isActive",
            headerName: (
                <div style={{ display: "flex", alignItems: "center" }}>
                    isActive
                {/* <div>
                    <FilterAltIcon
                        style={{ width: "15px", marginTop: "6px", marginLeft: "3px" }}
                        onClick={(e) => handleFilterClick(e, "isActive")}
                    />
                </div> */}
            </div>
            ),
            minWidth: 50,
            sortable: true,
            flex: 1,
            headerClassName: "center-header", 
            cellClassName: "center-cell", 
            renderCell: (params) => <div>
                <input type="checkbox" name="isActive" checked={params.row.isActive == 'yes' ? true : false}
                    onChange={(e) => handleUserAccessUpdate(e,params.row.Enterprise_ID)} />                 
            </div>
        },
        {
            field: "createdAt", minWidth: 90, sortable: true, flex: 0.7, headerClassName: "center-header", 
            cellClassName: "left-cell",
            align: 'left',
            headerName: (
                <div style={{ display: "flex", alignItems: "center" }}>
                    Created At               
                </div>
            ), 
            renderCell:(params)=><div>{params.row.createdAt?formatTimestamp(params.row.createdAt):"Not known"}</div>            
        }      
    ];

    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;

    const filteredOptions = Array.from(
        new Set(filteredData?.map((row) => row[currentColumn]))
    ).filter(
        (value) =>
        value && value.toString().toLowerCase().includes(searchTerm.toLowerCase())
    );    

    useEffect(() => {           
        setRows(filteredData);
    }, [filteredData]);

    let dataGridStyle = {
        "& .MuiDataGrid-columnHeader": {
            backgroundColor: "#022278",
            color: "white",
        },
        "& .MuiDataGrid-root": {
            width: "100%",
        },
        "& .MuiDataGrid-sortIcon": {
            color: "#fff",
        },
        "& .MuiDataGrid-columnHeader": {
            position: "sticky",
            top: 0,
            backgroundColor: "#022278",
            color: "#fff",
        },
        "& .MuiDataGrid-columnHeaders": {
            width: "var(--DataGrid-rowWidth)",
        },
        "& .MuiDataGrid-row": {
            backgroundColor: "white",
            width: "calc(100% - 2px)",
        },
        "& ..MuiDataGrid-topContainer": {
                  width: "1700px !important",
                }
    }    

    return (                
        <div className="datagrid-container-user" style={{ height: 400, width: "100%" }}>
            <DataGrid rows={rows} columns={columns} autoHeight={true} style={{ overflowX: 'auto' }}
                initialState={{pagination: {paginationModel: { page: 0, pageSize: 7 },},}} sx={dataGridStyle}                              
            />
            
            <div className="access-user-save">
                <button onClick={handleSubmitClick}>Save</button>                                
                {alertMsg && <div style={{position: 'absolute',top: '0%',left: '40%','text-align': 'left'}}>
                    <Alert severity="success">
                        <AlertTitle>Success</AlertTitle>
                        Your changes are saved.
                    </Alert>
                </div>}
            </div>
            
            <Popover id={id} open={open} anchorEl={anchorEl} onClose={handleFilterClose} anchorOrigin={{vertical: "bottom",horizontal: "left",}}>
                <TextField variant="outlined" margin="dense" fullWidth placeholder={`Search ${currentColumn}`} value={searchTerm}
                    sx={{"& .MuiInputBase-input": {fontSize: "0.8rem", padding: "8.5px 14px"}}}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
                <List dense>
                    {filteredOptions.map((value, index) => (
                        <ListItem key={index}sx={{padding: "2px"}}>
                            <FormControlLabel control={
                                    <Checkbox checked={selectedFilters[currentColumn]?.includes(value)} onChange={() => handleSelection(value, false)}/>
                                }   
                                label={value}                     
                                sx={{"& .MuiFormControlLabel-label": {fontSize: "0.8rem",padding: "0px"}}} 
                            />                        
                        </ListItem>
                    ))}
                </List>
                <Button onClick={handleReset}>Reset</Button>            
            </Popover>            
            {/* <ExcelDownload />                                     */}
        </div>
    );
};
  